import React, { useState } from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";

const SidebarLink = styled(Link)`
  display: flex;
  color: #111519;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  list-style: none;
  height: 56px;
  text-decoration: none;
  font-family: 'poppins';
  font-size: 1rem;
  font-style: normal;
  font-weight: 200;
  line-height: 24px;
  color: #fff;

  &:hover {
    background: #8626F4;
    cursor: pointer;
    color: #fff;
    font-weight: 500;
  }
  &:focus {
    background: #8626F4;
    cursor: pointer;
    font-weight: 500;
  }
`;

const SidebarLabel = styled.span`
  margin-left: 10px;
`;



const DropdownLink = styled(Link)`
  background: #a05ced14;
  height: 54px;
  padding-left: 3rem;
  display: flex;
  align-items: center;
  text-decoration: none;
  color: #fff;
  font-family: 'poppins';
  font-size: 16px;
  font-style: normal;
  font-weight: 200;
  line-height: 20px;
  margin: 0 10px;

  &:hover {
    background: #e7f3f9;
    cursor: pointer;
  }
  &:focus {
    background: #e6edf0;
    font-weight: 700;
    cursor: pointer;
  }
`;

const SubMenu = ({ item }) => {
  const [subnav, setSubnav] = useState(false);

  const showSubnav = () => setSubnav(!subnav);

  return (
    <>
      <SidebarLink to={item.path} onClick={item.subNav && showSubnav} >
        <div className="d-flex align-items-center w-100">
          {item.icon}
          <SidebarLabel>{item.title}</SidebarLabel>
        </div>
        {item.subNav && subnav
          ? item.iconOpened
          : item.subNav
          ? item.iconClosed
          : null}
      </SidebarLink>
      {subnav &&
        item.subNav.map((item, index) => {
          return (
            <DropdownLink to={item.path} key={index}>
              {item.icon}
              <SidebarLabel>{item.title}</SidebarLabel>
            </DropdownLink>
          );
        })}
    </>
  );
};

export default SubMenu;
